var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "enhancements-treat form" },
    [
      !_vm.haveIcon
        ? _c("div", { staticClass: "enhancements-image" }, [
            _c(
              "picture",
              {
                directives: [
                  {
                    name: "lazyload",
                    rawName: "v-lazyload",
                    value: {
                      src: _vm.enhancement.icon,
                      set: [
                        { width: "480", height: "240", breakpoint: "xs" },
                        { width: "800", height: "360", breakpoint: "md" },
                      ],
                      fit: "crop",
                      align: "center",
                    },
                    expression:
                      "{\n            src: enhancement.icon,\n            set: [\n              { width: '480', height: '240', breakpoint: 'xs' },\n              { width: '800', height: '360', breakpoint: 'md' }\n            ],\n            fit: 'crop',\n            align: 'center'\n          }",
                  },
                ],
                staticClass: "image-wrapper",
              },
              [
                _c("img", {
                  staticClass: "image",
                  attrs: {
                    src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                    alt: _vm.enhancement.name,
                  },
                }),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "enhancements-content-header" }, [
        _vm._v(_vm._s(_vm.enhancement.name)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "enhancements-content-description" }, [
        _vm._v(_vm._s(_vm.enhancement.description)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grid-2-col gutter-sm" }, [
        _c("div", { staticClass: "input dropdown" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.occasion,
                  expression: "occasion",
                },
              ],
              class: [{ filled: _vm.occasion }],
              attrs: {
                name: "occasion",
                placeholder: _vm.occasionLabel,
                id: "select-occasion",
                "aria-required": "true",
              },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.occasion = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.occasionOptions, function (option) {
              return _c(
                "option",
                { key: option, domProps: { value: option } },
                [_vm._v("\n          " + _vm._s(option) + "\n        ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "floating", attrs: { for: "select-occasion" } },
            [_vm._v("\n        " + _vm._s(_vm.occasionLabel) + "*\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "enhancements-content-subheader",
          attrs: { id: "celebratory-treat-group" },
        },
        [_vm._v(_vm._s(_vm.tc("enhancements.celebratoryTreatDateGroupTitle")))]
      ),
      _vm._v(" "),
      _c("selectable-group", {
        attrs: {
          "label-id": "celebratory-treat-group",
          options: _vm.dateOptions,
        },
        model: {
          value: _vm.date,
          callback: function ($$v) {
            _vm.date = $$v
          },
          expression: "date",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grid-2-col" }, [
        _c("div", { staticClass: "input dropdown" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.time,
                  expression: "time",
                },
              ],
              class: [{ filled: _vm.time }],
              attrs: {
                name: "occasion",
                id: "select-date",
                "aria-required": "true",
              },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.time = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.timeOptions, function (option) {
              return _c(
                "option",
                { key: option, domProps: { value: option } },
                [_vm._v("\n          " + _vm._s(option) + "\n        ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "floating req", attrs: { for: "select-date" } },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.tc("formFields.time")) + "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grid-1-col" }, [
        _c("div", { staticClass: "input" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.comment,
                expression: "comment",
              },
            ],
            class: [{ "have-value": !!_vm.comment }],
            attrs: {
              name: "comment",
              rows: "10",
              id: "celebratory-treat-comment",
            },
            domProps: { value: _vm.comment },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.comment = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "floating",
              attrs: { for: "celebratory-treat-comment" },
            },
            [_vm._v("\n        " + _vm._s(_vm.commentLabel) + "\n      ")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }